const securlyPlatformConfig = {
  clientId: import.meta.env.VITE_SECURLY_PLATFORM_CLIENT_ID || "",
  issuer:
    import.meta.env.VITE_SECURLY_PLATFORM_ISSUER ||
    "https://accounts.securly.com",
  scriptUrl:
    import.meta.env.VITE_SECURLY_PLATFORM_SCRIPT_URL ||
    "https://accounts.securly.com/securlyplatform.js"
}

export default securlyPlatformConfig
